import { useEffect, useState } from 'react';
import axios from 'axios';
import { useNavigate, useParams } from 'react-router-dom';
import Layout from '../shared/Layout';
import Icon from '../../components/tables/Icon';
import IconGoBack from '../../components/icons/IconGoBack';
import GroupModal from './GroupModal';
import GroupStats from './GroupStats';
import GroupMembersPanel from './GroupMembersPanel';
import GroupAttendanceTimeline from './GroupAttendanceTimeline';
import GroupTestsWidget from './GroupTestsWidget';
import GroupLessonsList from './GroupLessonsList';
import GroupCourses from './GroupCourses';
import language from '../../variables/language';
import '../../css/conversations.css';
import '../../css/groups.css';

export default function GroupCard() {
  const { id } = useParams();
  const navigate = useNavigate();
  const [group, setGroup] = useState(null);
  const [modalState, setModalState] = useState('none');
  const [refreshKey, setRefreshKey] = useState(0);

  useEffect(() => {
    axios.get('/api/groups/' + id, { withCredentials: true })
      .then(response => setGroup(response.data))
      .catch(err => {
        if (err.response && err.response.status === 401) navigate('/login');
      });
  }, [id, navigate, refreshKey]);

  const bumpRefresh = () => setRefreshKey(prev => prev + 1);
  const stateHundler = (state) => { if (state === 'edit') setModalState('edit'); };
  const closeModal = () => setModalState('none');
  const onSaved = () => { closeModal(); bumpRefresh(); };
  const onDeleted = () => navigate('/groups');

  const lang = language[language.lang];

  return (
    <Layout>
      <main className="main-block">
        <div className="main-content txt-c group-card-page">
          <div className="group-card-header">
            <div className="group-card-back" onClick={() => navigate('/groups')} title={lang.groupCard.backToGroups}>
              <IconGoBack />
            </div>
            <div className="group-card-title">{group ? group.name : '...'}</div>
            <div className="group-card-header-actions">
              <Icon mode="edit" id={id} stateHundler={stateHundler} className="icon-edit" classes="icon-dimensions-big" />
              <Icon mode="delete" url={'/api/groups/' + id} onRefreshHundler={onDeleted} className="icon-delete" classes="icon-dimensions-big" />
            </div>
          </div>

          {/* Stats tiles alone at the top, full width. */}
          <GroupStats groupId={id} refresh={refreshKey} />

          {/* Members | Courses | Tests as one equal-width, equal-height
              row (stretched via .group-card-columns-3-equal). */}
          <div className="group-card-columns-3-equal">
            <GroupMembersPanel groupId={id} refresh={refreshKey} onChange={bumpRefresh} />
            <GroupCourses groupId={id} refresh={refreshKey} />
            <GroupTestsWidget groupId={id} refresh={refreshKey} />
          </div>

          {/* Attendance gets a full-width row of its own (most of the
              screen) - a per-lesson horizontal timeline that genuinely
              benefits from the extra width. */}
          <GroupAttendanceTimeline groupId={id} refresh={refreshKey} onChange={bumpRefresh} />

          {/* Lessons also gets its own full-width row. */}
          <GroupLessonsList groupId={id} refresh={refreshKey} onChange={bumpRefresh} />
        </div>
      </main>
      <GroupModal modalState={modalState} groupId={id} onClose={closeModal} onSaved={onSaved} />
    </Layout>
  );
}
